import i18next from 'i18next';
import FILTER_TYPES from '../Shared/Table/widgets/Filters/constants';
import { CUSTOM_TAGS_OPTIONS, PATIENT_CUSTOM_TAGS_OPTIONS } from '../Shared/CustomTags';
import permissions from '../../config/permissions';
import { INFO_PANE_PAGES } from '../../redux_store';

export const BHI_STATUSES = {
  active: 'active',
  inactive: 'inactive',
};

export const BHI_STATUS_OPTIONS = [
  {
    label: i18next.t('tables:active'),
    value: BHI_STATUSES.active,
  },
  {
    label: i18next.t('tables:inactive'),
    value: BHI_STATUSES.inactive,
  },
];

export const GET_PROGRAMS_COLUMNS = (isPatientPage) => [
  {
    size: 270,
    header: i18next.t('tables:accountCustomTags'),
    accessorKey: 'accountCustomTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: PATIENT_CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:patientMrnNumber'),
    accessorKey: 'patientMrnNumber',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:patientFirstName'),
    accessorKey: 'patientFirstName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:patientLastName'),
    accessorKey: 'patientLastName',
    filter: {},
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:dateOfBirth'),
    accessorKey: 'dateOfBirth',
    filter: {
      filterType: FILTER_TYPES.DATE,
    },
    hidden: isPatientPage,
    cell: {
      infoPanePage: INFO_PANE_PAGES.patient_page,
    },
  },
  {
    size: 300,
    header: i18next.t('tables:programName'),
    accessorKey: 'title',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
      // filterType: FILTER_TYPES.SELECT,
      // options: ASSESSMENT_STATUSES_OPTIONS,
    },
    cell: {
      // infoPanePage: INFO_PANE_PAGES.program,
    },
  },
  {
    size: 200,
    header: i18next.t('tables:createdTimestamp'),
    accessorKey: 'createdTimestamp',
    filter: {
      shouldRange: true,
      filterType: FILTER_TYPES.DATE,
    },
    isDefaultCell: true,
  },
  {
    size: 150,
    header: i18next.t('tables:bhiStatus'),
    accessorKey: 'bhiStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: BHI_STATUS_OPTIONS,
    },
    cell: {
      withBubble: true,
    },
  },
];
